import React, { useEffect, useState } from 'react'
import "./style.scss"
import useScrolledHeight from '../../hooks/useScrolledHeight';
import OngoingApplications from '../../components/applications/OngoingApplications';
import CompletedApplications from '../../components/applications/CompletedApplications';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import AppliedApplications from '../../components/applications/AppliedApplications';
const Applications = () => {
    const location = useLocation();
    const [activeTab, setActiveTab] = useState<string>('ongoing');
    const [searchParams, setSearchParams] = useSearchParams();
    const scrolledHeight = useScrolledHeight();
    const navigate = useNavigate();

    const status = searchParams.get('status') ?? 'ongoing';

    useEffect(() => {
        if (location.pathname === '/applications') {
            navigate('/collaborations?status=applied');
        }
    }, [location.pathname])

    useEffect(() => {
        setActiveTab(status);
    }, [status])

    return (
        <div className='pt-5'>
            <div className={`app-nav px-3 border-bottom-1 justify-content-between applications-nav w-100 ${scrolledHeight > 0 ? 'bg-white' : ''}`}>
                <div className={`app-nav-item px-2 fs-16 ${activeTab === 'ongoing' ? 'text-dark fw-600 active' : 'text-muted fw-500'}`} onClick={() => setSearchParams({ status: 'ongoing' })}>
                    <span className=''>
                        <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12" fill="none">
                            <rect width="12" height="12" rx="6" fill="#DCFCE7" />
                            <circle cx="6" cy="6" r="3" fill="#16A34A" />
                        </svg>
                    </span>
                    Ongoing
                </div>
                <div className={`app-nav-item px-2 fs-16 ${activeTab === 'applied' ? 'text-dark fw-600 active' : 'text-muted fw-500'}`} onClick={() => setSearchParams({ status: 'applied' })}>Applied</div>
                <div className={`app-nav-item px-2 fs-16 ${activeTab === 'completed' ? 'text-dark fw-600 active' : 'text-muted fw-500'}`} onClick={() => setSearchParams({ status: 'completed' })}>Completed</div>
            </div>
            <div className="app-page p-0 overflow-hidden">
                {
                    activeTab === 'ongoing' && <OngoingApplications />
                }
                {
                    activeTab === 'completed' && <CompletedApplications />
                }
                {
                    activeTab === 'applied' && <AppliedApplications />
                }
            </div>
        </div>
    )
}

export default Applications